import { CircleHelp, Link2Off } from "lucide-react";
import { StatusScreen } from "@/components/common/StatusScreen";

/** Any URL that is not an interview link (inventory 15.8). */
export const NotFound = () => (
  <StatusScreen
    icon={CircleHelp}
    testId="not_found"
    title="Page not found"
    description="This address doesn't match an interview. Open the link from your interview email or your Simbiosis dashboard."
  />
);

/**
 * A room link without the role suffix. Every link the platform sends ends in
 * /interviewer or /interviewee, so this is a copy-paste that lost its end
 * (inventory 15.9).
 */
export const IncompleteLink = () => (
  <StatusScreen
    icon={Link2Off}
    testId="incomplete_link"
    title="This link is incomplete"
    description="Interview links end in /interviewer or /interviewee. Open the full link from your interview email or your Simbiosis dashboard."
  />
);
